/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Students_NewInputs */

const en_students_new = /** @type {(inputs: Students_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New student`)
};

const he_students_new = /** @type {(inputs: Students_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תלמיד חדש`)
};

/**
* | output |
* | --- |
* | "New student" |
*
* @param {Students_NewInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const students_new = /** @type {((inputs?: Students_NewInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Students_NewInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_students_new(inputs)
	return he_students_new(inputs)
});